import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/puntcity/images/logo.svg';

export default function index() {
  return <Image src={logo} mt={['14', null, 'unset']} />;
}
